export default "__VITE_ASSET__BUBfl2pi__"